import BTE from 'lib/BTE';

export const imageLoaded = ({ onLoad }) => {
  BTE.oneImageLoaded();
  if (onLoad) {
    onLoad();
  }
};
